export default __webpack_public_path__ + "static/mobile_landing-49e3bf0a4806019fe5fc4f5e2f2cba4d.png";